import { dateToYYYYMMDD } from '~/core/ts/util/date'
import { GetAwayAvailability, type GetAwayAvailabilityDTO } from '../../entity/GetAwayAvailability'

export default class GetAwayAPIRepository {
  static getUrlForSingleGetAway(getAwayUUIDs: Array<string>, from: Date, to: Date, pax: number): string {
    const runtime = useRuntimeConfig()

    const params = new URLSearchParams()
    params.append('pax', `${pax}`)
    params.append('from', dateToYYYYMMDD(from))
    params.append('to', dateToYYYYMMDD(to))
    params.append('uuids', getAwayUUIDs.join(','))

    const paramStr = params.toString()

    return `${runtime.public.apiBaseURL}/api/v1/web/packages/availability/all-info?${paramStr}`
  }

  static getUrlForLocationSearch(locationUUID: string, from: Date, to: Date, pax: number): string {
    const runtime = useRuntimeConfig()

    const params = new URLSearchParams()
    params.append('pax', `${pax}`)
    params.append('from', dateToYYYYMMDD(from))
    params.append('to', dateToYYYYMMDD(to))
    params.append('locations', locationUUID)

    const paramStr = params.toString()

    return `${runtime.public.apiBaseURL}/api/v1/web/packages/availability/all-info?${paramStr}`
  }

  static async getAvailabilityByUUIDs(uuids: Array<string>, from: Date, to: Date, pax: number): Promise<Array<GetAwayAvailability>> {
    const runtime = useRuntimeConfig()
    const language = runtime.public.language

    const url = this.getUrlForSingleGetAway(uuids, from, to, pax)

    const response = await fetch(url, {
      method: 'GEt',
      mode: 'cors',
      cache: 'no-cache',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json' }
    })

    if (!response.ok) {
      throw new Error('Cannot get availability for: ' + uuids.join(','))
    }

    const json = await response.json()
    const dtos: Array<GetAwayAvailabilityDTO> = json.data

    return dtos.map((dto) => GetAwayAvailability.from(dto, language))
  }

  static async getAvailabilityByLocation(locationUUID: string, from: Date, to: Date, pax: number): Promise<Array<GetAwayAvailability>> {
    const runtime = useRuntimeConfig()
    const language = runtime.public.language

    const url = this.getUrlForLocationSearch(locationUUID, from, to, pax)

    const response = await fetch(url, {
      method: 'GEt',
      mode: 'cors',
      cache: 'no-cache',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json' }
    })

    if (!response.ok) {
      throw new Error('Cannot get availability for location: ' + locationUUID)
    }

    const json = await response.json()
    const dtos: Array<GetAwayAvailabilityDTO> = json.data

    return dtos.map((dto) => GetAwayAvailability.from(dto, language))
  }
}
